import React from 'react'
import SVG from 'react-inlinesvg'
import {toAbsoluteUrl} from '../AssetHelpers'
type Props = {
  className?: string
  path: string
  svgClassName?: string
  fill?: string
}

const KTSVG: React.FC<Props> = ({className = '', path, svgClassName = 'mh-50px', fill}) => {
  const svgProps: any = {src: toAbsoluteUrl(path), className: svgClassName}

  if (fill) {
    svgProps.fill = fill
  }
  // return (
  //   <span className={`svg-icon ${className}`}>
  //     <SVG src={toAbsoluteUrl(path)} className={svgClassName} fill={fill} />
  //   </span>
  // )
  return (
    <span className={`svg-icon ${className}`}>
      <SVG {...svgProps} />
    </span>
  )
}

export {KTSVG}
